<!--GeneratorFlag:[NoChange]-->
<template>
	<kaveh-excel-import :key="ver" :entity="entity" :task="import" stream-address="aut/letter-tag/stream-create" @close="reset" @cancel="reset" />
</template>
<script>
	import { LetterTag } from '@/modules/aut/data/letter-tag/create'
	import { LetterTagService } from '@/modules/aut/services'
	export default {
		data()
		{
			return {
				ver: 0
			}
		},
		computed:
		{
			entity()
			{
				return LetterTag;
			},

			service()
			{
				return new LetterTagService();
			}
		},
		methods:
		{
			async import(payload)
			{
				return await this.service.create(payload, {HSR:false, HER:false});
			},

			reset()
			{
				this.ver = this.ver + 1;
			}
		}
	}
</script>